export default __webpack_public_path__ + "static/media/left_title.0aec65a8.svg";